import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Args, Flags } from '@oclif/core';
import { Queue } from '@switchboard-xyz/on-demand';

export default class QueueRmMrEnclave extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Remove allowed measurement from the queue';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    mrEnclave: Flags.string({
      description: 'Hex encoded mrEnclave',
      required: true,
    }),
  };

  static args = {
    queue: Args.string({
      description: 'The queue account to configure',
    }),
  };

  async run() {
    const { args, flags } = await this.parse(
      this.constructor as typeof QueueRmMrEnclave
    );

    const program = await this.program;

    const queue = new Queue(program, new web3.PublicKey(args.queue!));
    const ix = await queue.rmMrEnclaveIx({
      mrEnclave: new Uint8Array(Buffer.from(flags.mrEnclave, 'hex')),
    });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure queue mrEnclave');
  }
}
